/**
 * @function dataURLtoFile
 * @description Convierte un data URL (base64) a un objeto File
 * @param {string} dataURL - El data URL de la imagen (e.g. "data:image/jpeg;base64,...")
 * @param {string} filename - Nombre del archivo resultante
 * @returns {File} Objeto File generado a partir del data URL
 */
const dataURLtoFile = (dataURL, filename) => {
  const arr = dataURL.split(',')
  const mime = arr[0].match(/:(.*?);/)[1]
  const bstr = atob(arr[1])
  let n = bstr.length
  const u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new File([u8arr], filename, { type: mime })
}

/**
 * @function rotateImage
 * @description Rota una imagen 90 grados en sentido horario
 * @param {string} imageSrc - Data URL de la imagen a rotar
 * @returns {Promise<string>} Promesa que resuelve con el data URL de la imagen rotada
 */
const rotateImage = (imageSrc) => {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.onload = () => {
      const canvas = document.createElement('canvas')
      canvas.width = img.height
      canvas.height = img.width
      const ctx = canvas.getContext('2d')
      ctx.translate(canvas.width / 2, canvas.height / 2)
      ctx.rotate((90 * Math.PI) / 180)
      ctx.drawImage(img, -img.width / 2, -img.height / 2)
      resolve(canvas.toDataURL('image/jpeg', 0.92))
    }
    img.onerror = reject
    img.src = imageSrc
  })
}

/**
 * @function validateImageFile
 * @description Valida que un archivo sea una imagen JPG/JPEG y no exceda el tamaño máximo
 * @param {File} file - Archivo a validar
 * @param {number} maxSizeMB - Tamaño máximo en MB (por defecto 10)
 * @returns {{ valid: boolean, error: string | null }} Resultado de la validación
 */
const validateImageFile = (file, maxSizeMB = 10) => {
  if (!file) {
    return { valid: false, error: 'noFile' }
  }

  const validTypes = ['image/jpeg', 'image/jpg']
  if (!validTypes.includes(file.type)) {
    return { valid: false, error: 'invalidFormat' }
  }

  const sizeMB = file.size / (1024 * 1024)
  if (sizeMB > maxSizeMB) {
    return { valid: false, error: 'maxSize' }
  }

  return { valid: true, error: null }
}

export { dataURLtoFile, rotateImage, validateImageFile }
